import _ from 'lodash';
import {
  SAVE_APPLICATION_SUCCESS,
  DELETE_APPLICATION_SUCCESS,
  JOIN_WAITLIST_SUCCESS,
  SAVE_PROGRAM_START,
  SAVE_PROGRAM_SUCCESS,
  SAVE_PROGRAM_ERROR,
  GET_STUDENT_SUCCESS,
  GET_STUDENT_ERROR,
  GET_STUDENTINFO_START,
  GET_STUDENTINFO_SUCCESS,
  GET_STUDENTINFO_ERROR,
  REMOVE_WAITLIST_SUCCESS,
} from '../constants';
import {
  ADD_STUDENT,
  STUDENT_API_REQUEST,
  STUDENT_API_SUCCESS,
  STUDENT_API_FAILURE,
  ADD_STUDENT_PROGRAM,
  STUDENT_PROGRAM_API_REQUEST,
  STUDENT_PROGRAM_API_SUCCESS,
  STUDENT_PROGRAM_API_FAILURE,
  ADD_STUDENT_APPLICATIONS,
  STUDENT_APPLICATIONS_API_REQUEST,
  STUDENT_APPLICATIONS_API_SUCCESS,
  STUDENT_APPLICATIONS_API_FAILURE,
  NEW_APPLICATION_RANK,
  NEW_APPLICATION_RANK_DRAG,
  LOGGED_OUT_USER_ADDRESS,
  CLEAR_LOGGED_OUT_USER_ADDRESS,
  ADD_STUDENT_WAITLISTS,
  STUDENT_WAITLISTS_API_REQUEST,
  STUDENT_WAITLISTS_API_SUCCESS,
  STUDENT_WAITLISTS_API_FAILURE,
  STUDENT_API_REQUEST_BY_ID,
  STUDENT_API_SUCCESS_BY_ID,
  STUDENT_API_FAILURE_BY_ID
} from '../actions/actionTypes';

const initialState = {
  guardian: '',
  students: '',
  savedPrograms: [],
  id: '',
  userLoading: false,
  details: {
    data: {
      first_name: '',
      last_name: '',
      address: {
        address_1: '',
        city: '',
        state: '',
        zip_code: '',
      },
    },
  },
  studentInfo: {
    first_name: '',
  },
  resultInfo:{

  },
  studentApplications: {
    entities: {
      application: {},
    },
    results: [],
    loaded: false,
  },
  studentWaitlists: {
    entities: {
      waitlists: {},
    },
    results: [],
    loaded: false,
  },
  loggedOutUser: {
    formattedAddress: '',
    latlng: null,
    set: false,
  },
  error: null,
  getStudentAddress() {
    if (this.details.data.address) {
      return {
        latitude: Number(this.details.data.address.latitude),
        longitude: Number(this.details.data.address.longitude),
      };
    }
    return false;
  },
  getStudentHomeAddress() {
    const { address } = this.details.data;
    return address && address.address_1 ? `${address.address_1} ${address.city}, ${address.state} ${address.zip_code}` : '';
  },
  getStudentCurrentSchoolAddress() {
    if (this.details.data.current_school) {
      return {
        latitude: Number(this.details.data.current_school.address.latitude),
        longitude: Number(this.details.data.current_school.address.longitude),
      };
    }
    return false;
  },
};

export default function saveProgram(state = initialState, action) {
  switch (action.type) {
    case SAVE_APPLICATION_SUCCESS: {
            state.studentApplications.results.splice(action.payload.rank - 1, 0, action.payload.id);
      return {
        ...state,
        studentApplications: {
          ...state.studentApplications,
          entities: {
            ...state.studentApplications.entities,
            application: {
              ...state.studentApplications.entities.application,
              [action.payload.id]: {
                // ...state.studentApplications.entities.application[action.payload.id],
                directory_program: action.payload.programData || action.payload.respData.directory_program_data,
                rank: action.payload.rank,
                id: action.payload.respData.id,
                distance: action.payload.respData.distance,
              },
            },
          },
          results: [...state.studentApplications.results],
        },
      };
    }
    case NEW_APPLICATION_RANK: {
      const existingResults = Array.isArray(state.studentApplications.results)
        ? [...state.studentApplications.results]
        : [];

      const insertedId =
        (action.payload.respData && action.payload.respData.id) ||
        action.payload.id ||
        action.payload.applicationId;

      // remove any existing occurrence to avoid duplicates
      const filtered = existingResults.filter(r => r !== insertedId);

      // only treat rank as valid when it's a positive integer
      const hasValidRank =
        typeof action.payload.rank === 'number' && Number.isInteger(action.payload.rank) && action.payload.rank > 0;

      const insertIndex = hasValidRank
        ? Math.max(0, Math.min(action.payload.rank - 1, filtered.length))
        : filtered.length;

      const newResults = [...filtered.slice(0, insertIndex), insertedId, ...filtered.slice(insertIndex)];

      return {
        ...state,
        studentApplications: {
          ...state.studentApplications,
          entities: {
            ...state.studentApplications.entities,
            application: {
              ...state.studentApplications.entities.application,
              [insertedId]: {
                directory_program:
                  action.payload.programData ||
                  (action.payload.respData && action.payload.respData.directory_program_data),
                rank: hasValidRank ? action.payload.rank : undefined,
                id: insertedId,
                distance: action.payload.respData && action.payload.respData.distance,
              },
            },
          },
          results: newResults,
        },
      };
    }
    case DELETE_APPLICATION_SUCCESS: {
      return {
        ...state,
        studentApplications: {
          ...state.studentApplications,
          results: state.studentApplications.results.filter(program => program !== action.payload.id),
          entities: {
            directory_program: _.omit(state.studentApplications.entities.directory_program, action.payload.id),
            application: _.omit(state.studentApplications.entities.application, action.payload.id),
          },
        },
      };
    }
    case JOIN_WAITLIST_SUCCESS: {
      return {
        ...state,
        studentWaitlists: {
          ...state.studentWaitlists,
          entities: {
            ...state.studentWaitlists.entities,
            waitlists: {
              ...state.studentWaitlists.entities.waitlists,
              [action.payload.id]: {
                ...action.payload.respData,
              },
            },
          },
          results: [...state.studentWaitlists.results, action.payload.id],
        },
      };
    }
    case REMOVE_WAITLIST_SUCCESS:
      return {
        ...state,
        studentWaitlists: {
          ...state.studentWaitlists,
          entities: { waitlists: action.payload.newWaitlistEntities },
          results: action.payload.newWaitlistResults,
        },
      };
    case ADD_STUDENT_WAITLISTS: {
      const { result } = action.payload.studentWaitlists.normalStudentWaitlists;
      const { waitlist } = action.payload.studentWaitlists.normalStudentWaitlists.entities;
      return {
        ...state,
        studentWaitlists: {
          entities: {
            waitlists: {
              ...waitlist,
            },
          },
          results: result,
        },
      };
    }
    case STUDENT_WAITLISTS_API_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case STUDENT_WAITLISTS_API_SUCCESS: {
      return {
        ...state,
        studentApplications: {
          ...state.studentWaitlists,
          loaded: true,
        },
        loading: false,
        error: null,
      };
    }
    case STUDENT_WAITLISTS_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case SAVE_PROGRAM_START: {
      return {
        ...state,
        userLoading: true,
      };
    }
    case SAVE_PROGRAM_SUCCESS: {
      return {
        ...state,
        savedPrograms: [...state.savedPrograms, action.payload.applicationId],
      };
    }
    case SAVE_PROGRAM_ERROR: {
      return {
        ...state,
        userLoading: false,
      };
    }
    case GET_STUDENT_SUCCESS: {
      return {
        ...state,
        savedPrograms: [...state.savedPrograms, action.payload],
      };
    }
    case GET_STUDENT_ERROR: {
      return {
        ...state,
        userLoading: false,
      };
    }
    case GET_STUDENTINFO_START: {
      return {
        ...state,
      };
    }
    case GET_STUDENTINFO_SUCCESS: {
      const details = action.payload;
      return {
        ...state,
        details,
      };
    }
    case GET_STUDENTINFO_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case ADD_STUDENT: {
      const { studentInfo } = action.payload.studentInfo;
      return {
        ...state,
        studentInfo,
      };
    }
    case STUDENT_API_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case STUDENT_API_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case STUDENT_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case ADD_STUDENT_PROGRAM: {
      const { studentPrograms } = action.payload.studentPrograms;
      return {
        ...state,
        studentPrograms,
      };
    }
    case STUDENT_PROGRAM_API_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case STUDENT_PROGRAM_API_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case STUDENT_PROGRAM_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case ADD_STUDENT_APPLICATIONS: {
      const { result } = action.payload.studentApplications.normalStudentApplications;
      const { application } = action.payload.studentApplications.normalStudentApplications.entities;
      return {
        ...state,
        studentApplications: {
          entities: {
            application: {
              ...application,
            },
          },
          results: result,
        },
      };
    }
    case NEW_APPLICATION_RANK_DRAG: {
      const { ranks } = action.payload;
      return {
        ...state,
        studentApplications: {
          ...state.studentApplications,
          results: ranks,
        },
      };
    }
    case STUDENT_APPLICATIONS_API_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case STUDENT_APPLICATIONS_API_SUCCESS: {
      return {
        ...state,
        studentApplications: {
          ...state.studentApplications,
          loaded: true,
        },
        loading: false,
        error: null,
      };
    }
    case STUDENT_APPLICATIONS_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case LOGGED_OUT_USER_ADDRESS: {
      const { formattedAddress, latlng } = action.payload;
      return {
        ...state,
        loggedOutUser: {
          formattedAddress,
          latlng,
          set: true,
        },
      };
    }
    case CLEAR_LOGGED_OUT_USER_ADDRESS: {
      return {
        ...state,
        loggedOutUser: initialState.loggedOutUser,
      };
    }

    case STUDENT_API_REQUEST_BY_ID: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case STUDENT_API_SUCCESS_BY_ID: {
      return {
        ...state,
        resultInfo: action.payload.studentInfo,
      };
    }
    case STUDENT_API_FAILURE_BY_ID: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }




    default:
      return {
        ...initialState,
        ...state,
      };
  }
}
